import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import CreateDocument from './views/CreateDocument.vue'
import Dashboard from './views/Dashboard.vue'
import Settings from './views/Settings.vue'
import Nomenclature from './views/Nomenclature.vue'
import Invoices from './views/Invoices.vue'
import Checks from './views/Checks.vue'
import Check from './views/Check.vue'
import Quotations from './views/Quotations.vue'
import router from './router'
import firebase from 'firebase'
import InvoicesDetails from "@/views/InvoicesDetails.vue";

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/create-document/:collectionID?/:documentID?',
      name: 'CreateDocument',
      component: CreateDocument
    },
    {
      path: '/quotations/:limit?',
      name: 'Quotations',
      component: Quotations
    },
    {
      path: '/checks',
      name: 'Checks',
      component: Checks
    },
    {
      path: '/checks/edit-check/:checkID?',
      name: 'Check',
      component: Check
    },
    {
      path: '/invoices/:limit?',
      name: 'Invoices',
      component: Invoices,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/nomenclature',
      name: 'Nomenclature',
      component: Nomenclature,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/invoices/edit-invoice/:invoiceID?',
      name: 'InvoiceDetails',
      component: InvoicesDetails,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  var currentUser = {}
  if (localStorage.getItem('currentUser')) {
    try {
      currentUser = JSON.parse(localStorage.getItem('currentUser'));
    } catch (e) {
      localStorage.removeItem('currentUser');
    }
  }

  if ((currentUser.isAdmin === undefined || currentUser.isAdmin === false) && to.path !== '/login') {
    firebase.auth().signOut()
    next({
      path: '/login'
    })
  return
  }
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (currentUser.uid === undefined && to.path !== '/login') {
      next({
        path: '/login'
      })
    } else if (!currentUser.hasCompletedOnboarding && to.path !== '/settings') {
      next({
        path: '/settings'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})